import { render, staticRenderFns } from "./CheckoutVipOrderConfirmation.vue?vue&type=template&id=1440289b&scoped=true"
import script from "./CheckoutVipOrderConfirmation.vue?vue&type=script&lang=js"
export * from "./CheckoutVipOrderConfirmation.vue?vue&type=script&lang=js"
import style0 from "./CheckoutVipOrderConfirmation.vue?vue&type=style&index=0&id=1440289b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1440289b",
  null
  
)

export default component.exports